import {ProjectForm} from '../../project/models/form.model';
import {formTypes} from '../../form/form.constants';
import {IndustrialTaxExemptionRenewal} from '../../incentive/renewal/models/industrial-tax-exemption-renewal.model';
import {QualityJobsRenewal} from '../../incentive/renewal/models/quality-jobs-renewal.model';
import {RestorationTaxAbatementRenewal} from '../../incentive/renewal/models/restoration-tax-abatement-renewal.model';

export class PublicRecords extends ProjectForm {
  requestedNumber: number;
  isRequestCertified: boolean;

  constructor(publicRecordRequest?: any) {
    super(null, publicRecordRequest);
    publicRecordRequest = publicRecordRequest || {};
    this.type = formTypes.prr.abbrev;
    this.requestedNumber = publicRecordRequest ? publicRecordRequest.requestedNumber || 0 : 0;
    this.isRequestCertified = publicRecordRequest ? publicRecordRequest.isRequestCertified : false;
  }
  init() {
    super.init();
    this.type = formTypes.prr.abbrev;
  }

  get qualifier() {
    return '';
  }
}
